/**
* LoginFormMdule is a reusable Module to use the login module features
*/

// Angular
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Modules
import { MultiSelectModule } from 'primeng/multiselect';

// Own Components
import { MultiselectComponent } from
'libraries/module/formbuilder/fields/multiselect/multiselect.component';
import { FormFieldModule } from '../form-field/form-field.module';
import { IsCheckedPipe } from "libraries/module/formbuilder/fields/multiselect/is-checked.pipe";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { TextFieldModule } from "libraries/module/formbuilder/fields/text-field/text-field.module";
import { TextModule } from "libraries/module/formbuilder/fields/text/text.module";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MultiSelectModule,
        //TODO NG UPGRADE NgxErrorsModule,
        FormFieldModule,
        FontAwesomeModule,
        TextFieldModule,
        TextModule,
        FontAwesomeModule,
    ],
    declarations: [
        MultiselectComponent,
        IsCheckedPipe
    ],
    exports: [
        MultiselectComponent
    ]
})

export class MultiselectModule { }
